<template>
  <div>
    <!-- Page Title -->
    <h1 class="text-2xl font-medium text-gray-800 mb-8 p-6">Customize Accounts</h1>

    <!-- Account Section -->
    <div class="mb-8">
      <h2 class="text-sm font-medium text-gray-600 mb-4 uppercase tracking-wide">ACCOUNT</h2>
      <div class="relative">
        <select
            v-model="selectedAccountId"
            class="w-full p-4 border border-gray-300 rounded-lg bg-white text-gray-700 appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
        >
          <option v-for="acc in accounts" :key="acc.id" :value="acc.id">
            {{ acc.account_number }} - {{ acc.account_name }}
          </option>
        </select>
        <div class="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
          <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>
      </div>
    </div>

    <!-- Balances Section -->
    <div class="mb-8">
      <h2 class="text-sm font-medium text-gray-600 mb-4 uppercase tracking-wide">BALANCES</h2>
      <div class="flex flex-col md:flex-row gap-5">
        <div class="flex-1 bg-white rounded-lg p-4 flex items-center space-x-4 border border-gray-300">
          <div class="bg-white p-2 rounded-lg border">
            <component :is="Database" class="text-gray-500"/>
          </div>
          <div>
            <div class="text-base text-primary">Available</div>
            <div class="text-sm font-semibold text-gray-500">{{ selectedAccount?.available_balance }} EUR</div>
          </div>
        </div>

        <div class="flex-1 bg-white rounded-lg p-4 flex items-center space-x-4 border border-gray-300">
          <div class="bg-white p-2 rounded-lg border">
            <component :is="Database" class="text-gray-500"/>
          </div>
          <div>
            <div class="text-base text-primary">Accounting</div>
            <div class="text-sm font-semibold text-gray-500">{{ selectedAccount?.accounting_balance }} EUR</div>
          </div>
        </div>
      </div>
    </div>

    <!-- View Section -->
    <div class="mb-8">
      <h2 class="text-sm font-medium text-gray-600 mb-4 uppercase tracking-wide">VIEW</h2>
      <div class="space-y-3 p-4 border border-gray-200 bg-white rounded-xl">
        <!-- Account Number Row -->
        <div class="flex items-center justify-between gap-12 border-b border-gray-200 pb-2">
          <label class="w-1/3 text-primary font-medium">Account number</label>
          <span class="w-2/3 text-gray-700">{{ selectedAccount?.account_number }}</span>
        </div>

        <!-- Account Name Row -->
        <div class="flex items-center justify-between gap-8">
          <label class="w-1/3 text-primary font-medium whitespace-nowrap">Account name</label>
          <input
              v-model="accountName"
              type="text"
              class="w-2/3 flex-1 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              :placeholder="selectedAccount?.account_name || 'Enter account name'"
          />
        </div>
      </div>
    </div>

    <!-- Change Button -->
    <div class="flex justify-center">
      <button
          @click="updateAccountName"
          class="w-1/2 md:w-1/4 bg-primary text-white font-medium py-3 px-12 rounded-lg transition-colors duration-200"
      >
        CHANGE
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { Database } from 'lucide-vue-next'
import api from '@/services/api'

const accounts = ref([])
const selectedAccountId = ref(null)
const accountName = ref('')

const selectedAccount = computed(() => {
  return accounts.value?.find(acc => acc.id === selectedAccountId.value) || null;
})

watch(selectedAccount, (acc) => {
  if (acc) accountName.value = acc.account_name
})

const fetchAccounts = async () => {
  try {
    const res = await api.get('/accounts', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
    console.log("accounts",res.data);

    accounts.value = res.data; // فرض بر این که API آرایه برمی‌گردونه
    if (accounts.value?.length > 0) {
      selectedAccountId.value = accounts.value[0].id; // انتخاب اولین حساب
    }

  } catch (err) {
    console.error('Error fetching accounts:', err.response?.data || err)
  }
}

const updateAccountName = async () => {
  if (!selectedAccountId.value) return
  try {
    await api.put(`/accounts/${selectedAccountId.value}`, {
      account_name: accountName.value
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
    alert('Account name updated successfully!')
    await fetchAccounts() // refresh
  } catch (err) {
    console.error('Error updating account:', err.response?.data || err)
    alert('Failed to update account name.')
  }
}

onMounted(fetchAccounts)
</script>
